import { http as axios } from "@/general/utils/http";
import {
  PointNoticeCard,
  UserPointAchievement,
  RandomUserAvatar,
  LatestMessage
} from "@/general/store/models";

const resourceCMS = "/v1/cms";

export default class TopPageApi {
  /**
   * Retrieve user point achievement data
   *
   * @returns {UserPointAchievement} object UserPointAchievement
   */
  static async getUserPointAchievement(): Promise<UserPointAchievement> {
    return await axios.get(`api/user-point-achievement`);
  }

  /**
   * Retrieve point notice data
   *
   * @returns {PointNoticeCard[]} object PointNoticeCard
   */
  static async getPointNoticeCard(): Promise<PointNoticeCard[]> {
    return await axios.get(`api/point-notice-card`);
  }

  /**
   * Retrieve random user image
   *
   * @returns {RandomUserAvatar} object RandomUserAvatar
   */
  static async getRandomUserAvatar(): Promise<RandomUserAvatar[]> {
    return await axios.get(`api/random_user_avatar`);
  }

  /**
   * Retrieve latest messages
   *
   * @returns {LatestMessages} object Latest messages
   */
  static async getLatestMessages(): Promise<LatestMessage[]> {
    return await axios.get(`api/latest-messages`);
  }

  /**
   * ブロックコンテンツを取得する
   * @param params
   */
  static async getBlockContents({
    locationCode,
    contractID,
    courseID
  }: {
    locationCode?: string;
    contractID?: string | null | undefined;
    courseID?: string | null | undefined;
  }) {
    return await axios.get(`${resourceCMS}/block_contents`, {
      params: {
        locationCode,
        contract_id: contractID,
        course_id: courseID
      }
    });
  }

  /**
   * 特集ページを取得する
   */
  static async getSpecialPage({
    page_limit,
    view_area,
    contract_id,
    course_id,
    sp_id
  }: {
    page_limit?: string | null | undefined;
    view_area?: string | null | undefined;
    contract_id?: string | null | undefined;
    course_id?: string | null | undefined;
    sp_id?: string | null | undefined;
  }): Promise<any> {
    return await axios.get(`${resourceCMS}/special_page`, {
      params: {
        page_limit,
        view_area,
        contract_id,
        course_id,
        sp_id
      }
    });
  }
}
